document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.featured-products-swiper', {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.featured-swiper-nav.swiper-button-next',
      prevEl: '.featured-swiper-nav.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  });

  const swiperEl = document.querySelector('.featured-products-swiper');
  const arrowPrev = document.querySelector('.featured-products-swiper .swiper-button-prev');
  const arrowNext = document.querySelector('.featured-products-swiper .swiper-button-next');

  if (swiperEl && arrowPrev && arrowNext) {
    const updateArrowPosition = () => {
      const height = swiperEl.offsetHeight;
      arrowPrev.style.marginTop = `${height / 2 - 24}px`; // 24 = half arrow height
      arrowNext.style.marginTop = `${height / 2 - 24}px`;
    };

    // Set once after DOM load
    updateArrowPosition();

    // Also set after all images load (since height may change)
    window.addEventListener('load', updateArrowPosition);

    // Optional: recalculate on window resize
    window.addEventListener('resize', updateArrowPosition);
  }
});
